import { jsxs as n, jsx as o } from "react/jsx-runtime";
import { I as p, j as u } from "../../../vendor-EQDp64ng.js";
import { forwardRef as b, useContext as v } from "react";
import { BaseIcon as x } from "../../BaseIcon/index.js";
import { ItemRow as h } from "../../ItemRow/index.js";
import { useSelectFieldValueContext as $ } from "../SelectFieldContext/index.js";
import { c as e } from "../../../styles.module-BOlArovb.js";
const y = b(
  function({ placeholder: r, startIcon: c, ...i }, m) {
    const d = v(p), { selectedItems: f } = $(), s = d?.selectionManager.selectedKeys, l = s && s.size > 0 ? s.values().next().value : void 0, t = l === void 0 ? void 0 : f.get(l), a = c ? { iconProps: { icon: c } } : t?.decorationLeft;
    return /* @__PURE__ */ n(u, { ...i, ref: m, className: e.selectValue, children: [
      /* @__PURE__ */ n("span", { className: e.value, children: [
        a ? /* @__PURE__ */ o(h.DecorationLeft, { ...a }) : null,
        t ? /* @__PURE__ */ o("span", { className: e.singleValueLabel, children: t.label }) : /* @__PURE__ */ o("span", { className: e.placeholder, children: r })
      ] }),
      /* @__PURE__ */ o(x, { icon: "chevron-down", className: e.chevron })
    ] });
  }
);
export {
  y as SingleSelectValue
};
